/**
 * Normalizes GET /composio/webhooks/inbound-url response shapes.
 */
export function pickComposioInboundUrl(data) {
  if (!data) return '';
  if (typeof data === 'string') return data.trim();
  const direct =
    data.inbound_url ||
    data.inboundUrl ||
    data.url ||
    data.webhook_url ||
    data.webhookUrl;
  if (typeof direct === 'string' && direct.trim()) return direct.trim();
  if (data.data && typeof data.data === 'object') {
    return pickComposioInboundUrl(data.data);
  }
  return '';
}

/**
 * Project webhook URL returned on agent trigger create/update responses.
 */
export function pickComposioProjectWebhookUrl(data) {
  if (!data) return '';
  const direct =
    data.composio_webhook_url ||
    data.composioWebhookUrl ||
    data.project_webhook_url ||
    data.projectWebhookUrl ||
    data.webhook_url;
  if (typeof direct === 'string' && direct.trim()) return direct.trim();
  return '';
}

export function isComposioApiUnavailable(err) {
  const status = err?.response?.status;
  return status === 404 || status === 503;
}

/** Normalize GET /composio/webhooks/setup-status response. */
export function parseComposioSetupStatus(data) {
  const root = data?.data && typeof data.data === 'object' ? data.data : data || {};
  const deliveryMode = String(
    root.delivery_mode || root.deliveryMode || root.mode || '',
  ).toLowerCase();

  return {
    deliveryMode: deliveryMode || 'unknown',
    isSdkMode: deliveryMode === 'sdk',
    isWebhookMode: deliveryMode === 'webhook',
    sdkListenerRunning: Boolean(
      root.sdk_listener_running ?? root.sdkListenerRunning ?? root.listener_running,
    ),
    ready: Boolean(root.ready ?? root.is_ready),
    message: root.message || root.detail || root.status_message || '',
    inboundUrl: pickComposioInboundUrl(root.inbound_url ? root : data),
    subscriptionActive: Boolean(
      root.subscription_active ?? root.subscriptionActive ?? root.webhook_subscribed,
    ),
  };
}

export function getComposioDeliveryLabel(setup) {
  if (!setup) return 'Checking…';
  if (setup.isSdkMode) return 'SDK listener (local)';
  if (setup.isWebhookMode) return 'HTTP webhook (production)';
  return setup.deliveryMode || 'Unknown';
}

/** Poll-based Composio triggers are not instant (Gmail sent, Calendar, etc.). */
export function isLikelyPollingTrigger(slug = '') {
  const s = String(slug).toUpperCase();
  return (
    s.includes('GMAIL') ||
    s.includes('GOOGLE_CALENDAR') ||
    s.includes('OUTLOOK') ||
    s.includes('_POLL') ||
    s.includes('EMAIL_SENT')
  );
}
